const e={path:"/api/v1/users/me/accept_terms",method:"POST"};export{e as AcceptTermsOnUser};
